export default "__VITE_ASSET__Dy0GtMAn__"